// Necessary if using App Router to ensure this file runs on the client
'use client'

import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum'
import { VERSION } from '../utils/constants'

export default function DatadogInit({ datadogConfig }: { datadogConfig: any }) {
  datadogRum.init({
    applicationId: datadogConfig.APP_ID,
    clientToken: datadogConfig.CLIENT_TOKEN,
    site: datadogConfig.SITE,
    service: datadogConfig.SERVICE_NAME,
    env: datadogConfig.ENV,
    version: VERSION,
    sessionSampleRate: datadogConfig.SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: datadogConfig.SESSION_REPLAY_SAMPLE_RATE,
    trackUserInteractions: datadogConfig.TRACK_USER_INTERACTIONS,
    trackResources: datadogConfig.TRACK_RESOURCES,
    trackLongTasks: datadogConfig.TRACK_LONG_TASKS,
    enableExperimentalFeatures: [`feature_flags`],
    defaultPrivacyLevel:
      datadogConfig.DEFAULT_PRIVACY_LEVEL as DefaultPrivacyLevel,
    allowedTracingUrls: datadogConfig.ALLOWED_TRACING_URLS
      ? datadogConfig.ALLOWED_TRACING_URLS.split(`,`).map((url: string) => {
          return { match: url, propagatorTypes: [`datadog`] }
        })
      : [],
  })

  datadogRum.setGlobalContext({
    'cloud-cost-center': datadogConfig.CLOUD_COST_CENTER,
  })

  datadogConfig.abVariants?.split(`.`).forEach((abVariant: any) => {
    const experiment = abVariant.split(`_`)[0]
    const variant = abVariant.split(`_`)[1]

    datadogRum.addFeatureFlagEvaluation(experiment, variant)
  })

  if (typeof window !== `undefined`) {
    if (datadogConfig.posData) {
      datadogRum.setGlobalContextProperty(`data`, datadogConfig.posData)
    }
    if (datadogConfig.user) {
      datadogRum.setUser(datadogConfig.user)
    }
  }
  return null
}

export function sendDataDogError(error: Error, context?: any) {
  datadogRum.addError(error, context)
}
